import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import {
    selectHasParentRegistration,
    selectTeamModalOpen,
} from "../../../../redux/slices/appSettingsSlice";
import { selectAllowSubRegistrantToChangeRegRoleBasedOnEnabledTeams } from "../../../../redux/slices/p2pSettingsSlice";
import { selectCurrentRegistrationIndex } from "../../../../redux/slices/registrationSlice";
import RoleCard from "./RoleCard";

const ConnectedRoleCard = ({
    disabled = undefined,
    handleChange = () => {},
    ...rest
}) => {
    const teamModalOpen = useSelector(selectTeamModalOpen);
    const currentRegistration = useSelector(selectCurrentRegistrationIndex);
    const hasParentRegistration = useSelector(selectHasParentRegistration);
    const allowSubRegistrantToChangeRegRole = useSelector(
        selectAllowSubRegistrantToChangeRegRoleBasedOnEnabledTeams,
    );

    const isChildParticipant =
        currentRegistration > 0 || hasParentRegistration === true;

    const childParticipantDisabled = !!(
        isChildParticipant && !allowSubRegistrantToChangeRegRole
    );

    // Allow the disabled prop to be passed through
    // but give it some default functionality
    const _disabled =
        disabled && typeof disabled === "boolean" && disabled !== undefined
            ? disabled
            : childParticipantDisabled;

    const roleCardProps = {
        ...rest,
        disabled: _disabled,
        handleChange,
        teamModalOpen,
    };

    return <RoleCard {...roleCardProps} />;
};

ConnectedRoleCard.propTypes = {
    disabled: PropTypes.bool,
    handleChange: PropTypes.func,
};

export default ConnectedRoleCard;
